var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"list",attrs:{"gutter":[12, 4]}},_vm._l((_vm.emojis),function(emoji){return _c('a-col',{key:emoji.key,staticClass:"list_item",attrs:{"span":4},on:{"click":function($event){return _vm.$emit('onSelect', emoji.value)}}},[_vm._v(" "+_vm._s(emoji.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }